var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-padding "},[_c('CUserSignupForm',{attrs:{"token":_vm.token,"errors":_vm.errors,"minimum_password_length":_vm.minimum_password_length}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }